import MemberCommitteeModel from './member_committee_model';
export default Backbone.Collection.extend({
  model: MemberCommitteeModel
});